import './Testimonials.css'

const Testimonials = ({ 
  title = "Lo que dicen nuestros clientes",
  subtitle = "La confianza de nuestros clientes es nuestro mayor logro",
  testimonials = [],
  showCTA = true 
}) => {
  const defaultTestimonials = [
    {
      name: "María González",
      company: "Empresa ABC",
      text: "Excelente servicio contable. Vanesa siempre está disponible para resolver nuestras dudas y nos ayuda a mantener todo en orden.",
      rating: 5
    },
    {
      name: "Carlos Rodríguez",
      company: "Comercial XYZ",
      text: "Profesionalismo y dedicación en cada consulta. Recomiendo ampliamente sus servicios contables.",
      rating: 5
    },
    {
      name: "Ana Martínez",
      company: "Servicios Generales",
      text: "Gracias a su asesoramiento hemos optimizado nuestros procesos contables y fiscales.",
      rating: 5
    }
  ]

  const testimonialsToShow = testimonials.length > 0 ? testimonials : defaultTestimonials

  return (
    <section className="testimonials">
      <div className="container">
        <div className="testimonials__header">
          <h2 className="testimonials__title">{title}</h2>
          <p className="testimonials__subtitle">{subtitle}</p>
        </div>
        
        <div className="testimonials__grid">
          {testimonialsToShow.map((testimonial, index) => (
            <div key={index} className="testimonials__card">
              <div className="testimonials__card-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="testimonials__star">⭐</span>
                ))}
              </div>
              <blockquote className="testimonials__card-text">
                "{testimonial.text}"
              </blockquote>
              <div className="testimonials__card-author">
                <div className="testimonials__card-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="testimonials__card-info">
                  <div className="testimonials__card-name">{testimonial.name}</div>
                  <div className="testimonials__card-company">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {showCTA && (
          <div className="testimonials__cta">
            <a 
              href="https://wa.me/5491166201346" 
              target="_blank" 
              rel="noopener noreferrer"
              className="testimonials__cta-button"
            >
              📱 Consultar por WhatsApp
            </a>
          </div>
        )}
      </div>
    </section>
  )
}

export default Testimonials
